// src/abbreviate.ts
var abbreviate = (value, length) => {
  if (value === void 0 || value === null || length === void 0 || length === null) {
    return null;
  }
  return value.trim().length > length ? `${value.substring(0, length).trim()}...` : value.trim();
};
var abbreviate_default = abbreviate;

// src/formatAccount.ts
var padWithZero = (value, length) => {
  let paddedValue = value;
  while (paddedValue.length < length) {
    paddedValue = `0${paddedValue}`;
  }
  return paddedValue;
};
var formatAccountId = (accountId) => {
  if (accountId && accountId.length === 12) {
    return `${accountId.substring(0, 4)}-${accountId.substring(
      4,
      6
    )}-${accountId.substring(6, 12)}`;
  }
  return null;
};
var formatAccount = (branch, ledger, account) => {
  if (branch && branch.length > 0 && branch.length <= 4 && ledger && ledger.length === 2 && account && account.length > 0 && account.length <= 6) {
    return `${padWithZero(branch, 4)}-${ledger}-${padWithZero(account, 6)}`;
  }
  return null;
};
var formatAccount_default = formatAccount;

// src/formatCreditCard.ts
var formatCreditcard = (creditcard) => {
  if (creditcard && creditcard.length === 16) {
    return `${creditcard.substr(0, 4)}-${creditcard.substr(
      4,
      4
    )}-${creditcard.substr(8, 4)}-${creditcard.substring(12)}`;
  }
  return null;
};
var formatCreditCard_default = formatCreditcard;

// src/formatIban.ts
var formatIban = (iban) => {
  if (iban && iban.length < 35) {
    const arr = iban.match(/.{1,4}/g);
    let newIban = "";
    if (arr !== null) {
      newIban += arr[0];
      for (let i = 1; i < arr.length; i += 1) {
        newIban += " ";
        newIban += arr[i];
      }
      return newIban;
    } else {
      return iban;
    }
  }
  return null;
};
var formatIban_default = formatIban;

// src/formatKennitala.ts
var formatKennitala = (kennitala) => {
  if (kennitala && kennitala.length === 10) {
    return `${kennitala.substring(0, 6)}-${kennitala.substring(6, 10)}`;
  }
  return null;
};
var formatKennitala_default = formatKennitala;

// src/formatLoan.ts
var formatLoanId = (loanId) => formatAccountId(loanId);
var formatLoan = (branch, ledger, account) => formatAccount_default(branch, ledger, account);
var formatLoan_default = formatLoan;

// src/formatMoney.ts
import { formatFloat } from "@landsbankinn/l16n";
var formatMoney = (locale, amount, currencyCode, suffix) => {
  if (amount !== null && amount !== void 0 && currencyCode && locale) {
    const precision = currencyCode === "ISK" ? 0 : 2;
    const amountFormatted = formatFloat(
      locale,
      amount,
      precision
    );
    return suffix ? `${amountFormatted} ${currencyCode}` : amountFormatted;
  }
  return null;
};
var formatMoney_default = formatMoney;

// src/formatStringWithDelimeter.ts
var formatStringWithDelimeter = (unformattedString, delimeter, index) => {
  if (unformattedString && unformattedString.length > 1 && index > 0 && delimeter !== "" && index < unformattedString.length) {
    return [
      unformattedString.slice(0, index),
      delimeter,
      unformattedString.slice(index)
    ].join("");
  }
  return null;
};
var formatStringWithDelimeter_default = formatStringWithDelimeter;

// src/formatRealEstateReferenceId.ts
var formatRealEstateReferenceId = (realEstateReferenceId) => {
  if (realEstateReferenceId && realEstateReferenceId.length === 7) {
    return formatStringWithDelimeter_default(realEstateReferenceId, "-", 3);
  }
  return null;
};
var formatRealEstateReferenceId_default = formatRealEstateReferenceId;

// src/formatVehiclePermanentId.ts
var formatVehiclePermanentId = (vehiclePermanentId) => {
  if (vehiclePermanentId && vehiclePermanentId.length === 5) {
    return formatStringWithDelimeter_default(vehiclePermanentId, "-", 2);
  }
  return null;
};
var formatVehiclePermanentId_default = formatVehiclePermanentId;
export {
  abbreviate_default as abbreviate,
  formatAccount_default as formatAccount,
  formatAccountId,
  formatCreditCard_default as formatCreditCard,
  formatIban_default as formatIban,
  formatKennitala_default as formatKennitala,
  formatLoan_default as formatLoan,
  formatLoanId,
  formatMoney_default as formatMoney,
  formatRealEstateReferenceId_default as formatRealEstateReferenceId,
  formatVehiclePermanentId_default as formatVehiclePermanentId
};
//# sourceMappingURL=index.mjs.map